.wrapper {
  padding: calc(var(--nav-height) + 20px) var(--page-padding) 0;
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 6rem;
}

.header {
  padding: 4rem 0 3rem;
  text-align: center;
  position: relative;
}

.header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--color-border-default), transparent);
}

.title {
  font-family: var(--font-heading);
  font-size: clamp(2.2rem, 5vw, 3.2rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  margin-bottom: 0.5rem;
}

.updated {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.content {
  padding-top: 2rem;
}

.section {
  margin-bottom: 2.5rem;
}

.sectionTitle {
  font-family: var(--font-heading);
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-border-default);
}

.section p {
  color: var(--color-text-secondary);
  font-size: 0.98rem;
  line-height: 1.7;
  margin-bottom: 0.8rem;
}

.draftNotice {
  background: rgba(255, 136, 0, 0.08);
  border: 1px solid rgba(255, 136, 0, 0.3);
  border-left: 3px solid var(--neon-orange, #FF8800);
  border-radius: 8px;
  padding: 1rem 1.2rem;
  margin-bottom: 2rem;
}

.draftNotice strong {
  color: var(--neon-orange, #FF8800);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-size: 0.78rem;
  display: block;
  margin-bottom: 0.4rem;
}

.draftNotice p {
  color: var(--color-text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 2rem;
  color: var(--neon-cyan, #00F0FF);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
}

.backLink:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .header { padding: 3rem 0 2rem; }
}
